/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SlideFlag } from './SlideFlag';

export type LISLabOrder = {
    readonly id?: number;
    readonly case_id?: number;
    readonly block_id?: number;
    readonly slide_id?: number;
    readonly lab_stain_id?: number;
    readonly user_id?: number;
    type: LISLabOrder.type;
    /**
     * number representing the sequential order in which the slide's specimen was cut for this Order
     */
    sequence: number;
    /**
     * special instructions for the lab via the pathologist
     */
    note?: string | null;
    readonly created_at?: string;
    readonly updated_at?: string;
    cancelled_at?: string | null;
    completed_at?: string | null;
    readonly transmitting_at?: string;
    inadequate?: boolean;
    no_charge_reason?: LISLabOrder.no_charge_reason | null;
    readonly flag?: SlideFlag;
}

export namespace LISLabOrder {

    export enum type {
        STAIN = 'stain',
        RECUT = 'recut',
        RESCAN = 'rescan',
        LEVEL = 'level',
        OTHER = 'other',
        CONTROL = 'control',
    }

    export enum no_charge_reason {
        STAIN_NOT_OPTIMAL = 'stain-not-optimal',
        ACADEMIC = 'academic',
        NONCONTRIBUTORY = 'noncontributory',
        ORDERED_ERROR = 'ordered-error',
        INCORRECT_STAIN = 'incorrect-stain',
        PROCESSING_NOT_OPTIMAL = 'processing-not-optimal',
    }


}
